import { actionCopyEs } from "./actionCopy";

export const inviteCopyEs = {
    reviewSetup: "Comprobar la configuración",
    organisationAndContact: "Organización y contacto",
    addPatient: "Añadir un paciente",
    inviteByEmail: "Invitar por correo electrónico",
    shareQrCode: "Compartir el enlace / código QR",
    inviteSent: "Invitación enviada",
    inviteSentTo: (email) => `Invitación enviada a ${email}`,
    loading: actionCopyEs.loading,
    justAMoment: "Un momento...",
    patientEmailWillReceiveInstructions: (email) =>
        `${email} recibirá un correo electrónico con las instrucciones para empezar.`,
    patientPhoneWillReceiveInstructions: (phone) => `${phone} recibirá un SMS con las instrucciones para empezar.`,
    patientWillReceiveInstructions: "Su paciente recibirá un correo electrónico con las instrucciones para empezar.",
    emailAndMobileHint: "Ambos, si es posible.",
    emailOrPhoneRequired: "(o teléfono obligatorio)",
    mobileOrEmailRequired: "(o correo electrónico obligatorio)",
    diariesAddedInLast7Days: (count) => `En los últimos 7 días ha añadido ${count} diarios a Patient Watch.`,
    goToDiary: "Ir al diario",
    inviteAnotherPatient: "Invitar a otro paciente",
    whatWasInjected: "Producto inyectado",
    clinicians: "Clínicos",
    referringClinician: "Médico derivante",
    injectingClinician: "Médico que realiza la inyección",
    operatingSurgeon: "Cirujano",
    therapist: "Terapeuta",
    injectionMethod: "Método de inyección",
    questionnaires: "Cuestionarios",
    clinicContact: "Contacto de la clínica",
    surgeryDetails: "Información sobre la cirugía",
    injectionDetails: "Información sobre la inyección",
    treatmentDetails: "Información sobre el tratamiento",
    consultationDetails: "Información sobre la consulta",
    consultationName: "Nombre de la consulta",
    description: "Descripción",
    clinician: "Clínico",
    consultingClinician: "Clínico consultor",
    consultingClinicianDescription: "El clínico que ha realizado la consulta",
    productDetails: "Información sobre el producto",
    providingClinician: "Clínico prescriptor",
    providingClinicianDescription: "El clínico que ha prescrito, facilitado o configurado el producto",
    usageInstructions: "Instrucciones de uso",
    editInjectionDetails: "Modificar la información sobre la inyección",
    editInjectionClinicians: "Modificar los clínicos de la inyección",
    editSurgeryDetails: "Modificar la información sobre la cirugía",
    editSurgeryClinicians: "Modificar los clínicos de la cirugía",
    editShockwaveDetails: "Modificar la información sobre las ondas de choque",
    editShockwaveClinicians: "Modificar los clínicos de las ondas de choque",
    editConsultationDetails: "Modificar la información sobre la consulta",
    editConsultingClinician: "Modificar el clínico consultor",
    editProductDetails: "Modificar la información sobre el producto",
    editProvidingClinician: "Modificar el clínico prescriptor",
    editClinicContact: "Modificar el contacto de la clínica",
    notSet: "Sin definir",
    selected: "Seleccionado",
    unknownForm: "Formulario desconocido",
    unknownSchedule: "Calendario desconocido",
    noSide: "Ningún lado",
    email: "Correo electrónico",
    enterEmail: "Introducir la dirección de correo electrónico",
    titleOptional: "Título (opcional)",
    firstNameOptional: "Nombre (opcional)",
    lastNameOptional: "Apellidos (opcional)",
    mobileNumber: "Móvil",
    firstNamePlaceholder: "p. ej. Sherlock",
    lastNamePlaceholder: "p. ej. Holmes",
    selectPlaceholder: "Seleccionar",
    sendInvite: "Enviar la invitación",
    sendingInvite: "Enviando la invitación…",
    inviteSentToast: "Invitación enviada",
    existingPatient: "Paciente ya existente",
    existingPatientAddDiary: "Añadiremos este diario a su cuenta existente.",
    existingUser: "Usuario ya existente",
    existingUserAddToOrganisation: "Lo añadiremos a esta organización en lugar de crear una cuenta nueva.",
    existingSecretary: "Secretario ya existente",
    existingSecretaryAddAsYours: "Lo añadiremos como su secretario para esta organización.",
    diaryQuotaBlockedTitle: "Límite de diarios alcanzado",
    diaryQuotaUsage: (used: number, limit: number) =>
        `Ha utilizado ${used} diarios de ${limit} en este periodo de facturación.`,
    diaryQuotaBlockedDescription: "Pase a un plan superior para invitar a más pacientes con diarios.",
    diaryQuotaUpgradeCta: "Elegir un plan",
    diaryQuotaOwnerUnresolved:
        "No se ha podido determinar la cuota de diarios del clínico correspondiente. Asocie a este secretario con un clínico, o envíe la invitación después de haber iniciado sesión como dicho clínico.",
    noTemplateSelected: "Ningún modelo seleccionado. En primer lugar",
    createTemplate: "crear un modelo",
    createTemplateFirst: ".",
    organisation: "Organización",
    hospitalNumberOptional: "Número de historia clínica (opcional)",
    enterNhsHospitalNumber: "Introducir el número de historia clínica del NHS",
    hospitalNumberDescription: "Permite encontrar a este paciente en sus historias clínicas.",
    referenceDateLabel: "Fecha desde la que se cuentan los seguimientos",
    referenceDateStartToday: "Empezar hoy",
    referenceDateAskPatient: "Nos la indica el paciente",
    referenceDateStartTodayHint: "Los cuestionarios empiezan hoy. No se pide una fecha al paciente.",
    referenceDateAskPatientHint: "El paciente indica la fecha al configurar su diario.",
    selectOrganisationToContinue: "Seleccione una organización para continuar.",
    selectContactToContinue: "Seleccione una persona de contacto para continuar.",
    doctorEmailSharedWithPatient:
        "Este correo electrónico se comparte con el paciente; tenga cuidado antes de comunicarlo o de usarlo aquí.",
    enterPhoneNumber: "Introducir el número de teléfono",
    backToSetup: "Volver a la configuración",
    patientInvite: "Invitación del paciente",
    diaryQrCode: "Código QR del diario",
    diaryQrDescription:
        "Comparta este código QR o este enlace para que los pacientes puedan registrarse en el teléfono y empezar este diario. Los detalles de la configuración se han confirmado en el paso anterior.",
    generatingInviteLink: "Generando el enlace de invitación…",
    failedToCreateInviteLink: "No se ha podido crear el enlace de invitación",
    hospitalOnTheInvite: "Centro indicado en la invitación",
    changingOrganisationUpdatesLink: "Cualquier cambio actualiza el enlace y el código QR.",
    shownOnPatientSignupLink: "Se muestra en el enlace de registro del paciente.",
    patientWillChooseOrganisation: "El paciente elegirá entonces su propia organización en el momento del registro.",
    hospitalNumber: "Número de historia clínica",
    enterHospitalNumber: "Introducir el número de historia clínica",
    requiredForNhsOrganisations: "Se muestra para las organizaciones que recogen un número de historia clínica",
    copyLink: "Copiar el enlace",
    copyQrCode: "Copiar el código QR",
    copyInviteLink: "Copiar el enlace de invitación",
    invitePageTitle: "Invitar",
    roleAndOrganisation: "Rol y organización",
    navInviteDescription: "Invite a un clínico, un paciente o un secretario a Patient Watch.",
    tabEmail: "Correo electrónico",
    tabQrCode: "Código QR",
    optionalSuffix: "(opcional)",
};
